import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../utils/general";
import { useNavigate } from "react-router-dom";
import { handleLinkUpload } from "../../thunks/editor/linkThunk";

const EnterLink = ({ className }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [link, setLink] = useState("");
  const [selectedSlide, setSelectedSlide] = useState(1);

  const handleBack = () => {
    navigate("/tool/dashboard");
  };

  const handleLinkChange = (event) => {
    setLink(event.target.value);
  };

  const handleSlideChange = (event) => {
    setSelectedSlide(event.target.value);
  };

  const handleSubmit = () => {
    const linkPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/gm;
    if (!linkPattern.test(link)) {
      showToast("Invalid link format.", "", "danger");
      return;
    }
    console.log("Link:", link);
    console.log("Number of Slides:", selectedSlide);
    dispatch(handleLinkUpload(link, selectedSlide));
    // dispatch(handleEnterLink({ link, slides: selectedSlide }));
  };

  return (
    <div
      className={`flex flex-col bg-gray-100 h-full border shadow ${
        className || ""
      }`}
    >
      <div className="border-2 flex bg-gradient-to-b from-gray-200 to-white p-2 text-sm font-semibold">
        <h1>Create Video from Link</h1>
      </div>
      <div className="mt-[7%]">
        <div className="border-[3px] bg-white my-12 mx-auto rounded w-[60%] p-8 items-center">
          <h1 className="font-bold">Paste your website link to create video</h1>
          <input
            className="p-2 border-2 w-full rounded bg-transparent text-blue-400 mt-4"
            type="text"
            value={link}
            onChange={handleLinkChange}
          />
          <select
            name="slides"
            id="slides"
            className="border-2 p-[2px] justify-end
            ml-[83%] w-[100px] pr-2 rounded-md mt-4"
            value={selectedSlide}
            onChange={handleSlideChange}
          >
            {[...Array(10).keys()].map((num) => (
              <option key={num + 1} value={num + 1}>
                {num + 1}
              </option>
            ))}
          </select>
          <p className="font-semibold text-sm my-2">
            Currently, only links to Wikipedia and news articles are supported.
            We're gradually expanding the list of websites that can be used in
            the tool.
          </p>
        </div>
        <div
          className="flex justify-end mr-14
         items-center gap-2 "
        >
          <button
            onClick={() => navigate("/tool/dashboard")}
            className="text-black text-sm font-semibold rounded-md p-2 bg-white hover border border-black"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="text-white w-fit flex justify-end text-sm font-semibold rounded-md p-2 bg-black"
          >
            Create your first cut
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnterLink;
